import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import NetworkService from '../../services/NetworkService';

const StatusBar = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOnline', 'show'].includes(prop),
})`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${props => props.isOnline ? '#4CAF50' : '#f44336'};
  color: white;
  text-align: center;
  padding: 8px;
  font-size: 14px;
  z-index: 9999;
  transform: translateY(${props => props.show ? '0' : '-100%'});
  transition: transform 0.3s ease;
`;

const ConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(NetworkService.isOnline);
  const [show, setShow] = useState(false);
  const [connectionInfo, setConnectionInfo] = useState(null);

  useEffect(() => {
    const handleNetworkChange = (online, info) => {
      setIsOnline(online);
      setConnectionInfo(info);
      
      // Show status bar when connection changes
      setShow(true);
      setTimeout(() => setShow(false), 3000);
    };

    NetworkService.addListener(handleNetworkChange);
    
    return () => NetworkService.removeListener(handleNetworkChange);
  }, []);

  if (!show) return null;

  const getMessage = () => {
    if (!isOnline) return 'You are offline. Some features may be limited.';
    
    if (connectionInfo?.effectiveType === 'slow-2g' || connectionInfo?.effectiveType === '2g') {
      return 'Slow connection detected. Loading may take longer.';
    }
    
    return 'Connection restored!';
  };

  return (
    <StatusBar isOnline={isOnline} show={show}>
      {getMessage()}
    </StatusBar>
  );
};

export default ConnectionStatus; 